var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.20312L15.3125 2.96094C16.1875 1.42969 17.7734 0.5 19.5234 0.5H19.6875C22.3125 0.5 24.5 2.6875 24.5 5.3125C24.5 6.13281 24.2812 6.84375 23.9531 7.5H25.375C26.7969 7.5 28 8.70312 28 10.125V13.625C28 14.7734 27.2344 15.7578 26.25 16.1406V25C26.25 26.9688 24.6641 28.5 22.75 28.5H5.25C3.28125 28.5 1.75 26.9688 1.75 25V16.1406C0.710938 15.7578 0 14.7734 0 13.625V10.125C0 8.70312 1.14844 7.5 2.625 7.5H3.99219C3.66406 6.84375 3.5 6.13281 3.5 5.3125C3.5 2.6875 5.63281 0.5 8.3125 0.5H8.42188C10.1719 0.5 11.7578 1.42969 12.6328 2.96094L14 5.20312ZM15.75 10.125V13.625H25.375V10.125H15.75ZM12.25 10.125H2.625V13.625H12.25V10.125ZM12.25 16.25H4.375V25C4.375 25.4922 4.75781 25.875 5.25 25.875H12.25V16.25ZM15.75 25.875H22.75C23.1875 25.875 23.625 25.4922 23.625 25V16.25H15.75V25.875ZM19.6875 7.5C20.8906 7.5 21.875 6.57031 21.875 5.3125C21.875 4.10938 20.8906 3.125 19.6875 3.125H19.5234C18.7031 3.125 17.9922 3.5625 17.5547 4.27344L15.6406 7.5H19.6875ZM12.3047 7.5L10.3906 4.27344C9.95312 3.5625 9.24219 3.125 8.42188 3.125H8.3125C7.05469 3.125 6.125 4.10938 6.125 5.3125C6.125 6.57031 7.05469 7.5 8.3125 7.5H12.3047Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.28630c8c97eb4ccd6de920e8e4a2df7e.svg";
export { ForwardRef as ReactComponent };